/**
 * Created by shiyonggao on 2019/1/22.
 */

/**
 * 项目配置文件
 */

const config = {
    /**用户登陆token**/
    userLoginAccessTokenKey: 'odp5-access-token',
    udcAccessTokenKey: 'oasis-udc-token',
    passportAccessTokenKey: 'oasis-passport-token',
    isDebug: false,

    /**core配置 此三项删除**/
    coreAppId: 255, 
    coreUrl : 'https://core.mars-era.cn',
    coreOauthUrl: 'https://oauth-abroad.mars-era.cn',

    /**dev server port**/
    port: 8090,

    /**dev server index page**/
    index: 'index',
    projectTypeRoute1: 'gameConfig/baseInfo',
    projectTypeRoute2: 'watch/line',


    /**dev server auto open browser**/
    autoOpenBrowser: true,

    /**host udc 祁涛提供**/
    baseUrl: 'https://odp.mars.games/',
    apiBaseUrl: 'https://udp6.mars.games/v6',
    udcApiBaseUrl: 'https://udc.mars.games/api/', 
    userLogin: 'https://udp6.mars.games/sdk-auth/login',
    userLogoutApi: 'https://udp6.mars.games/sdk-auth/logout',
    userLogout: 'static/logout.html',

    /**pugin**/ 
    pay_package_url: 'https://package.pay.mars.games/index.html',//支付套餐
    attendenceUrl: 'https://watch.mars.games/plugin/game-clock/mylog',//我的打卡肌瘤
    lineUrl: 'https://watch.mars.games/plugin/three-compared-charts/',//监控曲线图
    alarmPolicyUrl: 'https://watch.mars.games/plugin/game-plans/list',//报警策略配置
    alarmGroupUrl: 'https://watch.mars.games/plugin/notif-groups/list',//报警群组配置



    /**api**/
    api: {
        /**Package管理**/
        package_ajax_game_region_list_url: '/ajaxrela/getgameregionlist',
        package_ajax_game_package_list_url: '/ajaxrela/getpackagenamelist',
        package_ajax_game_store_list_url: '/ajaxrela/getstore',
        package_games_list_url: '/games/{game_code}/packages',
        package_add_package_url: '/games/{game_code}/packages/new',
        package_edit_del_package_url: '/games/{game_code}/packages/{package_id}',
        package_server_list_region_url: '/ajaxrela/getserverlist',

        /**游戏运营**/
        push_ajax_rela_get_game_code_lang_url: '/ajaxrela/getgamecodelang',
        push_games_code_push_topic_group_url: '/games/{game_code}/push-topic-groups',
        push_push_topics_url: '/push-topics',
        push_add_games_code_push_topic_group_url: '/games/{game_code}/push-topic-groups/new',
        push_edit_games_code_push_topic_group_id_url: '/games/{game_code}/push-topic-groups/{topic_group_id}',
        push_add_schedules_url: '/games/{game_code}/push-schedules/new',
        push_schedules_list_url: '/games/{game_code}/push-schedules',
        push_delete_edit_schedules_by_id_url: '/games/{game_code}/push-schedules/{schedule_id}',
        push_plans_news: '/games/{game_code}/pushplans/new',
        push_get_plans_times: 'games/{game_code}/pushplans/times',
        push_get_os_platform_config: '/ajaxrela/getplatformconfig',
        push_get_all_users: '/ajaxrela/getuserlist',
        push_get_plans_detail: '/games/{game_code}/pushplans',
        game_unbind_account: '/ajaxrela/unbind-account',

        /** Anti Addiction **/
        anti_addiction_create_config: '/games/{game_code}/anti_addiction/add',
        anti_addiction_edit_config: '/games/{game_code}/anti_addiction/edit',
        anti_addiction_get_config: '/games/{game_code}/anti_addiction',
        anti_addiction_get_user_info: '/games/{game_code}/anti_addiction_info',

        /***server*/
        serverlist: '/games/{game_code}/servers',
        editServer: '/games/{game_code}/servers/',
        region: '/ajaxrela/getregion',
        batchMerge: '/games/{game_code}/servers/merge',
        batchMaintain: '/games/{game_code}/servers/editmaintain',
        batchDelMaintain: '/games/{game_code}/servers/delmaintain',
        batchOpen: "/games/{game_code}/servers/batchsetopentime",
        batchConfig: "/games/{game_code}/servers/batchsetdatasource",

        system: {
            add_version: '/sdk/{platform}/versions/new',
            get_version_list: '/sdk/{platform}/versions',
            get_version_info : '/sdk/{platform}/versions/{sdk_version_id}',
            remove_version: '/sdk/{platform}/versions/{sdk_version_id}',
            edit_version: '/sdk/{platform}/versions/{sdk_version_id}'
        },
        app: {
            get_game_info: '/games',
            get_ces_token: 'https://udp6.mars.games/sdk-auth/get-ces-token',
            get_game_list: 'https://udp6.mars.games/sdk-auth/get',
            baseinfo: '/games/{game_code}',
            test_reg: '/ajaxrela/registernum',
            test_server: '/ajaxrela/serverlist',
            test_online: '/ajaxrela/onlinenum',
            test_role: '/ajaxrela/userrole',
            check_regionjustify: '/games/{game_code}/regionjustify',
        },

        /**cp参数导出**/
        cpargexport: {
            get: '/games/{game_code}',
            save: '/games/{game_code}',
            get_packages: '/ajaxrela/getpackagenamelist',
            get_store_by_package: '/ajaxrela/getpackagenamestorelist',
            get_sdk_version_by_package_and_channel: '/ajaxrela/getsdkversionbypackagestore',
            get_plan: '/games/{game_code}/plans',
            get_adjust_token: '/games/{game_code}/adjust-tokens',
        },
        /**数据查询**/
        query: {
            on_paid: '/games/{game_code}/order-logs/on-paid',
            on_game_notified: '/games/{game_code}/order-logs/on-game-notified',
            get_user_data: '/games/{game_code}/datasearchUser',
            get_user_relevant_data: '',
            device: '/games/{game_code}/datasearchDevice',
            get_connect: '/ajaxrela/getconnect',
            activity_order_resend_list: '/games/{game_code}/activity-order/list',
            activity_order_resend_one: '/games/{game_code}/activity-reissue',
            activity_order_resend_batch: '/games/{game_code}/activity-reissue/batch',
            activity_order: '/games/{game_code}/activity-order/list',
            sdk_release_record: '/publish-statistics/list',
            package_lists: '/publish-statistics/packages',
            sdk_version_lists: '/publish-statistics/sdk_versions',
        },
        /**活动页面管理**/
        activity_page: {
            list: '/game-act-pages/list',
            add: '/game-act-pages/add',
            edit: '/game-act-pages/edit/{id}',
        },
        plugin: {
            package_token: '/games/{game_code}/get-token/pay',
        }
    },

    /**默认语言**/
    locale: 'zh-CN',

    /**
     * 版本号
     */
    version: 'v2.0.0',
    /**
     * google Analytics measurement id
     */
     measurement_id: 'G-PTS0KRRE9W',
};
module.exports = config;


// WEBPACK FOOTER //
// ./website/config/config.js